import React from "react";

import { CopyToClipboardInput } from "../../../components/CustomInput/CopyToClipboardInput";
import { ActivateIcon } from "../../../components/icons/ActivateIcon";

interface IProps {
  keyName?: string;
  keyData?: string;
  loadingStatus: boolean;
  userExist: boolean;
  isTouchcast?: boolean;
  getStarted: () => void;
}

const CongratulationComponent: React.FC<IProps> = ({
  loadingStatus,
  userExist,
  keyName,
  keyData,
  isTouchcast,
  getStarted,
}) => {
  return (
    <>
      {userExist ? (
        <div className="azs-main-wrapper">
          <div className="azs-container">
            <div className="azs-big-title">Congratulations!</div>
            <div className="azs-medium-title">
              {isTouchcast
                ? "Your CogCache account is ready to go."
                : "Your subscription is now activated and your CogCache account created."}
            </div>
            <div className="azs-desc mb-7">
              Next, integrate CogCache in minutes with the endpoint and API key
              provided below.&nbsp;
              <a
                className="sample-code-link"
                target="_blank"
                rel="noreferrer"
                href="https://cogcache.readme.io/reference/quick-start"
              >
                See sample code here.
              </a>
            </div>
            <form className="azs-form-wrapper">
              <div className="azs-form-fields-wrapper">
                <div className="azs-input-fields azs-api-endpoint">
                  <CopyToClipboardInput
                    label="CogCache endpoint"
                    inputValue={process.env.REACT_APP_PURCHASE_URL || ""}
                    fullWidth={true}
                  />
                </div>
                <div className="azs-input-fields azs-api-key">
                  <CopyToClipboardInput
                    label={keyName}
                    inputValue={keyData || "Loading..."}
                    fullWidth={true}
                    isLoading={loadingStatus}
                  />
                </div>
                <div className="azs-info-label">
                  Please save this CogCache API key somewhere safe and
                  accessible. You won’t have the opportunity to copy it again in
                  the future.
                </div>
              </div>
              <div className="azs-btn-build-wrapper">
                <button
                  type="button"
                  className={`btn btn-secondary ${
                    loadingStatus ? "disabled" : ""
                  }`}
                  onClick={getStarted}
                  id="btn-get-started"
                >
                  {!loadingStatus && "Continue to your account"}
                  {!loadingStatus && (
                    <span>
                      <ActivateIcon />
                    </span>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      ) : (
        <div className="onboarding-loading">
          <span className="indicator-progress" style={{ display: "block" }}>
            Please wait...{" "}
            <span className="spinner-border spinner-border-sm align-middle ms-2" />
          </span>
        </div>
      )}
    </>
  );
};

export { CongratulationComponent };
